"use client";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useStore} from "@/store";
import FloatSearch from "@/components/Floating/FloatSearch";
import FloatMenu from "@/components/Floating/FloatMenu";
import {SIZES} from "@/components/constants";
import {IoCloseSharp} from "react-icons/io5";
import {useMediaQuery} from "react-responsive";

const FloatingContent = observer(()=> {
    const {floatAreaStore} = useStore();
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    return(
        <FloatingContentWrap
            className={`${floatAreaStore.isFloatingContent ? "active" : ""}`}
        >
            <div className={"dimmed"} onClick={()=>{
                floatAreaStore.setFloatingClear();
            }}></div>
            <div className={"content-wrap"}>
                {
                    isTablet &&
                    <div className={"close-btn"}  onClick={()=>{
                        floatAreaStore.setFloatingClear();
                    }}>
                        <IoCloseSharp size={24} color={"#000"}/>
                    </div>
                }
                {
                    floatAreaStore.isFloatingContent &&
                    <>
                        {
                            floatAreaStore.isFloatingContent === "search" ?
                                <FloatSearch />
                                :
                                <FloatMenu />
                        }
                    </>
                }
            </div>
        </FloatingContentWrap>
    )
});
const FloatingContentWrap = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 101;
    opacity: 0;
    visibility: hidden;
    transition: all .3s ease-in-out;
    .dimmed{
        transition: all .3s ease-in-out;
        background: rgba(0, 0, 0, 0.6);
        width: 100%;
        height: 100%;
        cursor: pointer;
            opacity: 0;
            visibility: hidden;
    }
    .content-wrap{
        transition: all .3s ease-in-out;
        position: absolute;
        top: 0;
        right: -880px;
        z-index: 99;
        background-color: #fff;
        width: 880px;
        height: 100%;
        border-radius: 60px 0 0 60px;
        overflow: hidden;
        .close-btn{
            cursor: pointer;
            position: absolute;
            top: 14px;
            right: 16px;
        }
    }
    &.active{
        opacity: 1;
        visibility: visible;
        .dimmed{
            opacity: 1;
            visibility: visible;
        }
        .content-wrap{
            right: 0;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .content-wrap{
            right: -100%;
            width: 100%;
            border-radius: 0;
        }
    }
`
export default FloatingContent;